// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-iam-access-dialog-access-list-direct-accesses-table-controls {
  display: flex;
}
.dl-iam-access-dialog-access-list-direct-accesses-table-controls__change-role {
  display: flex;
  flex: 1;
  position: relative;
}
.dl-iam-access-dialog-access-list-direct-accesses-table-controls__change-role-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.dl-iam-access-dialog-access-list-direct-accesses-table-controls__change-role-select {
  flex: 1;
}
.dl-iam-access-dialog-access-list-direct-accesses-table-controls__delete-role {
  margin-left: 8px;
}
.dl-iam-access-dialog-access-list-direct-accesses-table-controls__delete-role-icon {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/AccessList/DirectAccessesTable/Controls/Controls.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;AACJ;AACI;EACI,aAAA;EACA,OAAA;EACA,kBAAA;AACR;AAEI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAAR;AAGI;EACI,OAAA;AADR;AAII;EACI,gBAAA;AAFR;AAKI;EACI,YAAA;AAHR","sourcesContent":[".dl-iam-access-dialog-access-list-direct-accesses-table-controls {\n  display: flex;\n}\n.dl-iam-access-dialog-access-list-direct-accesses-table-controls__change-role {\n  display: flex;\n  flex: 1;\n  position: relative;\n}\n.dl-iam-access-dialog-access-list-direct-accesses-table-controls__change-role-loader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.dl-iam-access-dialog-access-list-direct-accesses-table-controls__change-role-select {\n  flex: 1;\n}\n.dl-iam-access-dialog-access-list-direct-accesses-table-controls__delete-role {\n  margin-left: 8px;\n}\n.dl-iam-access-dialog-access-list-direct-accesses-table-controls__delete-role-icon {\n  opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
